const customSelectors = {};
class customJS {
    constructor() {
    }
}

window.onload = () => {
    if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
    }
}; 

typeof customJS !== 'undefined' && new customJS();


// let wave = gsap.fromTo(".addon-wave img", { xPercent:0 }, { xPercent:-30 });

// ScrollTrigger.create ({
//     trigger: ".addon-wave",
//     animation: wave,
//     start: "top bottom",
//     end: "bottom top",
//     markers: true
// });

document.addEventListener("DOMContentLoaded", () => {
    var gsapCheck = setInterval(function() {
        if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
            clearInterval(gsapCheck);
            
            gsap.registerPlugin(ScrollTrigger);
            const waveElement = document.querySelector(".addon-wave img");
            const waveTarget = document.querySelector(".addon-wave");
            var wave = gsap?.to(waveElement,{x:-1000 });
            if(waveElement && waveTarget){
                ScrollTrigger.create ({
                    trigger: waveTarget,
                    animation: wave,
                    start: "top 98%",
                    end: "top 0%",
                    scrub: 1.5
                });
            }
            const factorySvgTarget = document.querySelector(".content-bg-img");
            const factorySvgParentTarget = document.querySelector(".heading-animation-parent");
            if(factorySvgTarget && factorySvgParentTarget){
                var factory_svg_animation = gsap.to(".content-bg-img", {x: 0});
                ScrollTrigger.create({
                    trigger: factorySvgParentTarget,
                    animation: factory_svg_animation,
                    start: "top 30%",
                    end: "top 30%",
                    scrub: true,
                    once: true
                });
            }
            
            let mm = gsap.matchMedia();

            if(mm){
                mm.add("(max-width: 767px)", () => {
                    const factoryHeadingTarget = document.querySelector(".heading-animation");
                    if(factoryHeadingTarget){
                    var factory_heading_animation = gsap?.fromTo(factoryHeadingTarget, { y: 50, "-webkit-text-fill-color": "transparent" }, { y: 0, "-webkit-text-fill-color": "#5F259F" });
                        ScrollTrigger.create({
                            trigger: factoryHeadingTarget,
                            animation: factory_heading_animation,
                            start: "top 50%",
                            end: "top 50%"
                        });
                    }
                });
            }
            
            let mm_1 = gsap.matchMedia();
            if(mm_1){
                mm_1.add("(min-width: 992px)", () => {
                    const svgThreeItemsTarget = document.querySelector(".svg-three-items");
                    if(svgThreeItemsTarget){
                    var svgThreeItemsAnimation = gsap?.fromTo(svgThreeItemsTarget, { top: "15%" }, { top: "-30%" });
                        if(svgThreeItemsTarget && svgThreeItemsAnimation){
                            ScrollTrigger.create({
                                trigger: svgThreeItemsTarget,
                                animation: svgThreeItemsAnimation,
                                start: "top 50%",
                                end: "top 50%",
                                scrub: 1.5,
                                once: true
                            });
                        }
                    }
                });
            }
            
            let mm_2 = gsap.matchMedia();
            if(mm_2){
                mm_2.add("(min-width: 768px)", () => {
                    const headingAnimationTarget = document.querySelector(".heading-animation");
                    const headingParentTarget = document.querySelector(".heading-animation-parent");
                    if(headingAnimationTarget && headingParentTarget){
                        gsap.fromTo( ".heading-animation", { backgroundSize: "0%" }, { backgroundSize: "100%", ease: "none", x: 0,
                            scrollTrigger: {
                                trigger: headingParentTarget,
                                start: "top 30%",
                                end: "top 30%",
                                scrub: true,
                                once: true
                            }
                        }); 
                    }    
                });
            }
        }
    }, 150);
});








